export default "__VITE_ASSET__e9d8ac1a__"